import { on } from 'delegated-events'
import easydropdown from 'easydropdown'
import scrollTo from '../common/scrollTo'

const fn = {
    init: () => {
        on(
            'change',
            '.js-navigation-dropdown select',
            fn.handleNavigationSelect
        )
        on('change', '.js-anchor-dropdown select', fn.handleAnchorSelect)
        on('change', '.js-submit-dropdown select', fn.handleSubmitSelect)

        fn.setup()
    },

    setup: () => {
        document.querySelectorAll('.js-dropdown').forEach(($select) => {
            if (!$select.querySelector('[selected]')) {
                $select.selectedIndex = -1
            }

            fn.setupDropdown($select)
        })
    },

    handleNavigationSelect: (e) => {
        window.location.href = e.target.value
    },

    handleAnchorSelect: (e) => {
        const $target = document.querySelector(e.target.value)

        if ($target) {
            scrollTo($target).then(() => (e.target.selectedIndex = -1))
        }
    },

    handleSubmitSelect: (e) => {
        e.target.closest('form').submit()
    },

    setupDropdown: ($el) => {
        if ($el.tagName !== 'SELECT') {
            return
        }

        const $placeholder = $el.querySelector('option[value=""]')

        if ($placeholder && !$placeholder.hasAttribute('data-placeholder')) {
            $placeholder.setAttribute('data-placeholder', true)
        }

        const opts = {
            behavior: {
                openOnFocus: true,
                maxVisibleItems: 8,
                liveUpdates: true,
            },
        }

        easydropdown($el, opts)
    },
}

export const StyledDropdown = {
    init: ($select) => fn.setupDropdown($select),
    setup: () => fn.setup(),
}

export default {
    can: () => true,
    run: fn.init,
}
